// autogenerated by channel_search/generate.py -- do not edit
import { battery_prediction_t } from "@skydio/lcm/types/flight_deck/battery_prediction_t";
export { battery_prediction_t };

export const VEHICLE_BATTERY_PREDICTION = {
  channel: "VEHICLE_BATTERY_PREDICTION",
  channelId: 13552,
  type: battery_prediction_t
};
